module.exports = __webpack_public_path__ + "img/HalfHumanLogo.3f09da3a.png";